import { Col, Row, Nav, Container } from 'react-bootstrap'
import { useParams } from 'react-router-dom';

const Footer = () => {
    const { home } = useParams() || {};
    const currentHome = home || '';
    const baseUrl = currentHome ? `/${currentHome}` : '';

    return (
            <footer style={{ fontFamily: "'Open Sans', sans-serif", flexShrink: 0, width: "100%" }}>
            <Container fluid style={{"background":"#006699"}}>
                <br></br>
                <Row>
                    <Col xs={12} md={6} className="justify-content-center d-flex">
                        <Nav className="flex-column">
                            <Nav.Link className="text-light" href={`${baseUrl}/`}>Home</Nav.Link>
                            <Nav.Link className="text-light" href={`${baseUrl}/aboutUs`}>About Us</Nav.Link>
                            <Nav.Link className="text-light" href={`${baseUrl}/privacy_policy`}>Privacy Policy</Nav.Link>
                            <Nav.Link className="text-light" href={`${baseUrl}/terms_of_use`}>Terms of use</Nav.Link>
                        </Nav>
                    </Col>
                    <Col xs={12} md={6} className="justify-content-center d-flex">
                        <Nav className="flex-column">
                                <Nav.Link className="text-light text-center" href={`${baseUrl}/contactUs`}>Contact Us</Nav.Link> 
                                <Nav.Link className="text-light" href="tel:519-434-9700">help@carepassport.ca</Nav.Link>     
                        </Nav>
                    </Col>
                   
                    {/* <Col className="justify-content-center d-flex d-none d-md-block">
                        <Nav className="flex-row pt-4">
                        
                            <Nav.Link target="_blank" href={SOCIAL_MEDIA_URLS.TWITTER}  className="text-dark px-1">
                                <SlSocialTwitter style={{"fontSize":"2pc"}}/>
                            </Nav.Link>
                            <Nav.Link target="_blank" href={SOCIAL_MEDIA_URLS.FACEBOOK}  className="text-dark px-1">
                                <SlSocialFacebook style={{"fontSize":"2pc"}}/>
                            </Nav.Link>
                            <Nav.Link target="_blank" href={SOCIAL_MEDIA_URLS.YOUTUBE} className="text-dark px-1">
                                <SlSocialYoutube style={{"fontSize":"2pc"}}/>
                            </Nav.Link>
                        </Nav> 
                    </Col> */}
                    
                </Row>
                <div className="text-center mt-4" style={{color: "white", fontFamily: "'Open Sans', sans-serif"}}>
                    {/* <div className="justify-content-center d-flex d-md-none">
                        <Nav className="flex-row pt-4 justify-content-center">
                            <Nav.Link target="_blank" href={SOCIAL_MEDIA_URLS.TWITTER}  className="text-dark px-1">
                                <SlSocialTwitter style={{"fontSize":"2pc"}}/>
                            </Nav.Link>
                            <Nav.Link target="_blank" href={SOCIAL_MEDIA_URLS.FACEBOOK}  className="text-dark px-1">
                                <SlSocialFacebook style={{"fontSize":"2pc"}}/>
                            </Nav.Link>
                            <Nav.Link target="_blank" href={SOCIAL_MEDIA_URLS.YOUTUBE} className="text-dark px-1">
                                <SlSocialYoutube style={{"fontSize":"2pc"}}/>
                            </Nav.Link>
                        </Nav> 
                    </div> */}
                    <small className="mt-5">&copy; CARE-LTC, </small> <br/>
                    <small className="mt-5">All Rights Reserved. </small><br/>
                    <small className="mt-5">Powered By Council for the Advancement of Resident-care Education in Long Term Care</small>
                </div>
            </Container>
            </footer>
    )
}

export default Footer;
